var render = function render(){var _vm=this,_c=_vm._self._c;return _c('profit-loss-document-page',{attrs:{"direction":"loss"}})
}
var staticRenderFns = []

export { render, staticRenderFns }